var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKycClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic20-close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8856 11.9998L19.6095 6.27583C20.1308 5.7545 20.1308 4.91184 19.6095 4.39051C19.0882 3.86918 18.2455 3.86918 17.7242 4.39051L12.0002 10.1145L6.27631 4.39051C5.75498 3.86918 4.91232 3.86918 4.391 4.39051C3.86967 4.91184 3.86967 5.7545 4.391 6.27583L10.1149 11.9998L4.391 17.7238C3.86967 18.2451 3.86967 19.0878 4.391 19.6091C4.65099 19.8691 4.99232 19.9998 5.33365 19.9998C5.67498 19.9998 6.01631 19.8691 6.27631 19.6091L12.0002 13.8851L17.7242 19.6091C17.9842 19.8691 18.3255 19.9998 18.6668 19.9998C19.0082 19.9998 19.3495 19.8691 19.6095 19.6091C20.1308 19.0878 20.1308 18.2451 19.6095 17.7238L13.8856 11.9998Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKycClose);
export default __webpack_public_path__ + "static/media/kycClose.184fa3f382a5421b2f6c566f4aee3891.svg";
export { ForwardRef as ReactComponent };